import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MapContainer, TileLayer, Marker, Popup, Polygon } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Button } from '@mui/material';
import Actions_Wind from '~/Actions_Wind';

import marker_icon from 'leaflet/dist/images/marker-icon.png';
// import iconShadow from 'leaflet/dist/images/marker-shadow.png';
const icon = L.icon({
  iconUrl: marker_icon,
  iconSize: [30, 50], // size of the icon
  iconAnchor: [15, 50], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -55], // point from which the popup should open relative to the iconAnchor
});

function getRandomColor () {
  const letters = '0123456789ABCDEF'.split('');
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const App = ({ setId }) => {
  const dispatch = useDispatch();
  const treeWidth = useSelector(state => state.treeWidth);
  const getGisData = () => Actions_Wind.Gis.getGisData(dispatch);
  useEffect(() => {
    getGisData();
  }, []);
  const location_list = useSelector(state => (state.data.GisData || {}).location_list || []);
  const position = [23.5, 121.4];
  return (
    <MapContainer style={{ height: '100%', width: '100%', borderRadius: 30 }} center={position} zoom={9} scrollWheelZoom>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://wmts.nlsc.gov.tw/wmts/EMAP5/default/EPSG:3857/{z}/{y}/{x}'
        // url='https://wmts.nlsc.gov.tw/wmts/EMAP2/default/EPSG:3857/{z}/{y}/{x}'
        // url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {/* {
        location_list.map((o = {}, i) => o.point_list.map((o2, i2) => (
          <Marker key={`${i}_${i2}`} position={[o2.lat, o2.lng]} icon={icon}>
            <Popup>
              {o.name}
              <br />
              <Button>檢視</Button>
            </Popup>
          </Marker>
        )))
      } */}
      {location_list.map((o = {}, i) => (
        <Polygon key={i} positions={o.point_list.map((o2, i2) => [o2.lat, o2.lng])} color={getRandomColor()}>
          <Popup>
            {o.name}
            <br />
            <Button onClick={() => setId(o.windcontract_id)}>檢視</Button>
          </Popup>
        </Polygon>
      ))}
    </MapContainer>
  );
};
export default App;
